import * as React from "react";

const auditConfig   = (t) => {
    return {
        defaultTab: "verification",
        tabs: [
            {
                title: t("auditConfig.verification"),
                type: "verification",
                additionalFields: [
                    {
                        label: "ID",
                        field: "verificationId",
                        width: 200
                    }
                ],
                infoAction: {
                    redirectTo: function(verification) {
                        return `/#/verification/${verification.verificationId}`;
                    }
                }

            },
            {
                title: t("auditConfig.verificationTemplates"),
                type: "toolSetTemplate",
                additionalFields: [
                    {
                        label: "ID",
                        field: "templateId",
                        width: 200
                    }, {
                        label: t("auditConfig.name"),
                        field: "templateName",
                        width: 200
                    }
                ]
            },
            {
                title: t("auditConfig.toolVerification"),
                type: "tool",
                additionalFields: [
                    {
                        label: t("auditConfig.verID"),
                        field: "verificationId",
                        width: 200
                    },
                    {
                        label: t("auditConfig.toolNumber"),
                        field: "toolNumber",
                        width: 200
                    },
                    {
                        label: t("auditConfig.toolType"),
                        field: "toolType",
                        width: 200,
                        type: "enum",
                        enumType: "enums/toolType",
                    }

                ],
                infoAction: {
                    redirectTo: function(tool) {
                        return `/#/verification/${tool.verificationId}/?tool=${tool.toolId}`;
                    }
                }

            }
        ]

    };
}
export default auditConfig;